import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import {
    actionAppearance, bulkDeleteModal, checkAll,
    formCheck, formFail, formSuccess, handleSubmitActions,
    iAmHigherAuthority, isBannerPresent,
    paginateData, showModal, formCheckV2,
    sortFunc, searchFunc
} from "../libs.jsx";
import {Suspense, useEffect, useState} from "react";
import {CSVLink} from "react-csv";
import Button from "./component-assets/Button.jsx";
import ApiRequester from "./ApiRequester.jsx";
import TableBody from "./component-assets/TableBody.jsx";
import {Modal} from "bootstrap";
import {toast, ToastContainer} from "react-toastify";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import {Pagination} from "react-bootstrap";
import PaginationItems from "./component-assets/PaginationItems.jsx";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import SingleDeleteModal from "./component-assets/SingleDeleteModal.jsx";
import BulkDeleteModal from "./component-assets/BulkDeleteModal.jsx";
import PerPageModal from "./component-assets/PerPageModal.jsx";
import Navigation from "./Navigation.jsx";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton.jsx";

const PalPendantSettings = (props) => {
    let dData, bData, headerData, csvHeaders;

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    headerData = [
        {label: "Name", key: "profile_name", align: "center"}
    ];

    csvHeaders = [
        {label: "Name", key: "profile_name"}
    ];

    // Main Table Data Variables
    const [read, setRead] = useState(true);
    const [dataOrigin, setDataOrigin] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [typesData, setTypesData] = useState([]);
    const [addTabItem, setAddTabItem] = useState("idle");
    const [editTabItem, setEditTabItem] = useState("idle");
    const [editFormCheck, setEditFormCheck] = useState(false);
    const [originLoaded, setOriginLoaded] = useState(false);
    const [typesLoaded, setTypesLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [skeleton, setSkeleton] = useState(<TableSkeleton />);
    // Add Form Idle Variables
    const [addTxtSizeIdle, setAddTxtSizeIdle] = useState(1);
    const [addLineOneDataTypeIdle, setAddLineOneDataTypeIdle] = useState("");
    const [addLineTwoDataTypeIdle, setAddLineTwoDataTypeIdle] = useState("");
    const [addLineThreeDataTypeIdle, setAddLineThreeDataTypeIdle] = useState("");
    const [addLineOneTextIdle, setAddLineOneTextIdle] = useState("");
    const [addLineTwoTextIdle, setAddLineTwoTextIdle] = useState("");
    const [addLineThreeTextIdle, setAddLineThreeTextIdle] = useState("");
    const [addLineOneSuffixIdle, setAddLineOneSuffixIdle] = useState(false);
    const [addLineTwoSuffixIdle, setAddLineTwoSuffixIdle] = useState(false);
    const [addLineThreeSuffixIdle, setAddLineThreeSuffixIdle] = useState(false);
    const [addLineOneDisplayIdle, setAddLineOneDisplayIdle] = useState("");
    const [addLineTwoDisplayIdle, setAddLineTwoDisplayIdle] = useState("");
    const [addLineThreeDisplayIdle, setAddLineThreeDisplayIdle] = useState("");
    // Add Form Panic Variables
    const [addTxtSizePnc, setAddTxtSizePnc] = useState(1);
    const [addLineOneDataTypePnc, setAddLineOneDataTypePnc] = useState("");
    const [addLineTwoDataTypePnc, setAddLineTwoDataTypePnc] = useState("");
    const [addLineThreeDataTypePnc, setAddLineThreeDataTypePnc] = useState("");
    const [addLineOneTextPnc, setAddLineOneTextPnc] = useState("");
    const [addLineTwoTextPnc, setAddLineTwoTextPnc] = useState("");
    const [addLineThreeTextPnc, setAddLineThreeTextPnc] = useState("");
    const [addLineOneSuffixPnc, setAddLineOneSuffixPnc] = useState(false);
    const [addLineTwoSuffixPnc, setAddLineTwoSuffixPnc] = useState(false);
    const [addLineThreeSuffixPnc, setAddLineThreeSuffixPnc] = useState(false);
    const [addLineOneDisplayPnc, setAddLineOneDisplayPnc] = useState("");
    const [addLineTwoDisplayPnc, setAddLineTwoDisplayPnc] = useState("");
    const [addLineThreeDisplayPnc, setAddLineThreeDisplayPnc] = useState("");
    // Add Form Accepted Variables
    const [addTxtSizeAccept, setAddTxtSizeAccept] = useState(1);
    const [addLineOneDataTypeAccept, setAddLineOneDataTypeAccept] = useState("");
    const [addLineTwoDataTypeAccept, setAddLineTwoDataTypeAccept] = useState("");
    const [addLineThreeDataTypeAccept, setAddLineThreeDataTypeAccept] = useState("");
    const [addLineOneTextAccept, setAddLineOneTextAccept] = useState("");
    const [addLineTwoTextAccept, setAddLineTwoTextAccept] = useState("");
    const [addLineThreeTextAccept, setAddLineThreeTextAccept] = useState("");
    const [addLineOneSuffixAccept, setAddLineOneSuffixAccept] = useState(false);
    const [addLineTwoSuffixAccept, setAddLineTwoSuffixAccept] = useState(false);
    const [addLineThreeSuffixAccept, setAddLineThreeSuffixAccept] = useState(false);
    const [addLineOneDisplayAccept, setAddLineOneDisplayAccept] = useState("");
    const [addLineTwoDisplayAccept, setAddLineTwoDisplayAccept] = useState("");
    const [addLineThreeDisplayAccept, setAddLineThreeDisplayAccept] = useState("");
    // Edit Form Idle Variables
    const [editEntityIdIdle, setEditEntityIdIdle] = useState(0);
    const [editTxtSizeIdle, setEditTxtSizeIdle] = useState(1);
    const [editLineOneDataTypeIdle, setEditLineOneDataTypeIdle] = useState("");
    const [editLineTwoDataTypeIdle, setEditLineTwoDataTypeIdle] = useState("");
    const [editLineThreeDataTypeIdle, setEditLineThreeDataTypeIdle] = useState("");
    const [editLineOneTextIdle, setEditLineOneTextIdle] = useState("");
    const [editLineTwoTextIdle, setEditLineTwoTextIdle] = useState("");
    const [editLineThreeTextIdle, setEditLineThreeTextIdle] = useState("");
    const [editLineOneSuffixIdle, setEditLineOneSuffixIdle] = useState(false);
    const [editLineTwoSuffixIdle, setEditLineTwoSuffixIdle] = useState(false);
    const [editLineThreeSuffixIdle, setEditLineThreeSuffixIdle] = useState(false);
    const [editLineOneDisplayIdle, setEditLineOneDisplayIdle] = useState("");
    const [editLineTwoDisplayIdle, setEditLineTwoDisplayIdle] = useState("");
    const [editLineThreeDisplayIdle, setEditLineThreeDisplayIdle] = useState("");
    // Edit Form Panic Variables
    const [editEntityIdPnc, setEditEntityIdPnc] = useState(0);
    const [editTxtSizePnc, setEditTxtSizePnc] = useState(1);
    const [editLineOneDataTypePnc, setEditLineOneDataTypePnc] = useState("");
    const [editLineTwoDataTypePnc, setEditLineTwoDataTypePnc] = useState("");
    const [editLineThreeDataTypePnc, setEditLineThreeDataTypePnc] = useState("");
    const [editLineOneTextPnc, setEditLineOneTextPnc] = useState("");
    const [editLineTwoTextPnc, setEditLineTwoTextPnc] = useState("");
    const [editLineThreeTextPnc, setEditLineThreeTextPnc] = useState("");
    const [editLineOneSuffixPnc, setEditLineOneSuffixPnc] = useState(false);
    const [editLineTwoSuffixPnc, setEditLineTwoSuffixPnc] = useState(false);
    const [editLineThreeSuffixPnc, setEditLineThreeSuffixPnc] = useState(false);
    const [editLineOneDisplayPnc, setEditLineOneDisplayPnc] = useState("");
    const [editLineTwoDisplayPnc, setEditLineTwoDisplayPnc] = useState("");
    const [editLineThreeDisplayPnc, setEditLineThreeDisplayPnc] = useState("");
    // Edit Form Accept Variables
    const [editEntityIdAccept, setEditEntityIdAccept] = useState(0);
    const [editTxtSizeAccept, setEditTxtSizeAccept] = useState(1);
    const [editLineOneDataTypeAccept, setEditLineOneDataTypeAccept] = useState("");
    const [editLineTwoDataTypeAccept, setEditLineTwoDataTypeAccept] = useState("");
    const [editLineThreeDataTypeAccept, setEditLineThreeDataTypeAccept] = useState("");
    const [editLineOneTextAccept, setEditLineOneTextAccept] = useState("");
    const [editLineTwoTextAccept, setEditLineTwoTextAccept] = useState("");
    const [editLineThreeTextAccept, setEditLineThreeTextAccept] = useState("");
    const [editLineOneSuffixAccept, setEditLineOneSuffixAccept] = useState(false);
    const [editLineTwoSuffixAccept, setEditLineTwoSuffixAccept] = useState(false);
    const [editLineThreeSuffixAccept, setEditLineThreeSuffixAccept] = useState(false);
    const [editLineOneDisplayAccept, setEditLineOneDisplayAccept] = useState("");
    const [editLineTwoDisplayAccept, setEditLineTwoDisplayAccept] = useState("");
    const [editLineThreeDisplayAccept, setEditLineThreeDisplayAccept] = useState("");
    // Permission Variables
    const [addRights, setAddRights] = useState(iAmHigherAuthority(20, dData?.role_weight));
    const [editRights, setEditRights] = useState(iAmHigherAuthority(20, dData?.role_weight));
    const [deleteRights, setDeleteRights] = useState(iAmHigherAuthority(20, dData?.role_weight));
    // Main Table Control Variables
    const [count, setCount] = useState(0);
    const [storePage, setStorePage] = useState(1);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState([]);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [storedIndex, setStoredIndex] = useState(0);
    const [dataIdList, setDataIdList] = useState([]);
    const [oldDataIdList, setOldDataIdList] = useState([]);
    const [search, setSearch] = useState("");
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [sorter, setSorter] = useState({
        sortColumn: "area_name",
        sortOrder: "asc"
    });
    const [csvLink, setLink] = useState({
        filename: "palpendantlineprofiles.csv",
        headers: [],
        data: []
    });
    const [csvButton, setCSVButton] = useState(
        <CSVLink {...csvLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
        </CSVLink>);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                payload: {campus_id: dData.acnt}, "read-only": read,
                                procedure: "getppendantdspprofiles", reqType: "stored"}).then(data => {
                setDataOrigin(data);
                setOriginLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_palpendant_data_type",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setTypesData(data);
                setTypesLoaded(true);
            });
            setRead(true);
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        setLink(prevState => {
            return {...prevState,
                headers: csvHeaders,
                data: dataOrigin}
        });
    }, [dataOrigin]);

    useEffect(() => {
        setCSVButton(
            <CSVLink {...csvLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"}
                        class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        );
    }, [csvLink]);

    useEffect(() => {
        if (![originLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [originLoaded]);

    useEffect(() => {
        let tmpData, pRules, searchKeys;

        searchKeys = ["profile_name"];
        tmpData = searchFunc(search, dataOrigin, searchKeys);

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setActiveData(tmpData);
    }, [search, dataOrigin]);

    useEffect(() => {
        let pRules = paginateData(activeData, page, perPage);
        setPRules(pRules);
        if (activeData.length > 0) {
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeData} checkbox={deleteRights}
                                writeAccess={editRights} unk={"a-"}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteBtn"])}
                                tableHeaders={headerData} editModal={editModal} modal={editRights && typesLoaded} parentComponent={"PalPendantSettings"}
                                dData={dData} checkboxlist={dataIdList}
                                setCheckboxId={(value) => {setDataIdList(value)}} checkidkey={"dsp_profile_id"} />);
    }, [activeData, sorter, page, perPage, dataIdList, typesLoaded]);

    useEffect(() => {
        if (addTabItem === "idle"){
            document.getElementById("add-idle-tab").classList.add("active");
            document.getElementById("add-pnc-tab").classList.remove("active");
            document.getElementById("add-accept-tab").classList.remove("active");
        }else if (addTabItem === "pnc"){
            document.getElementById("add-pnc-tab").classList.add("active");
            document.getElementById("add-idle-tab").classList.remove("active");
            document.getElementById("add-accept-tab").classList.remove("active");
        }else if (addTabItem === "accept"){
            document.getElementById("add-accept-tab").classList.add("active");
            document.getElementById("add-idle-tab").classList.remove("active");
            document.getElementById("add-pnc-tab").classList.remove("active");
        }
    }, [addTabItem]);

    useEffect(() => {
        if (editTabItem === "idle"){
            document.getElementById("edit-idle-tab").classList.add("active");
            document.getElementById("edit-pnc-tab").classList.remove("active");
            document.getElementById("edit-accept-tab").classList.remove("active");
        }else if (editTabItem === "pnc"){
            document.getElementById("edit-pnc-tab").classList.add("active");
            document.getElementById("edit-idle-tab").classList.remove("active");
            document.getElementById("edit-accept-tab").classList.remove("active");
        }else if (editTabItem === "accept"){
            document.getElementById("edit-accept-tab").classList.add("active");
            document.getElementById("edit-idle-tab").classList.remove("active");
            document.getElementById("edit-pnc-tab").classList.remove("active");
        }
    }, [editTabItem]);

    function handleDisplay(dataType, customText, useSuffix, txtSize, setDisplay){
        let txtSample = "";
        if (dataType === 1){
            txtSample = `${customText}`;
        }else if (dataType === 2){
            txtSample = `${customText ? (!useSuffix ? customText + " " : "") : ""}Jane Doe${customText ? (useSuffix ? " " + customText : "") : ""}`
        }else if (dataType === 3){
            txtSample = `${customText ? (!useSuffix ? customText + " " : "") : ""}Room 101${customText ? (useSuffix ? " " + customText : "") : ""}`
        }else if (dataType === 4){
            txtSample = `${customText ? (!useSuffix ? customText + " " : "") : ""}Staff Mary${customText ? (useSuffix ? " " + customText : "") : ""}`
        }
        setDisplay(txtSize === 1 ? txtSample.slice(0,20) : txtSample.slice(0,14));
    }

    useEffect(() => {
        if (editFormCheck){
            formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
            formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
            formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
            formCheck("editForm", "editSubmit");
            setEditFormCheck(false);
        }
    }, [editFormCheck]);

    useEffect(() => {
        handleDisplay(addLineOneDataTypeIdle, addLineOneTextIdle, addLineOneSuffixIdle, addTxtSizeIdle, setAddLineOneDisplayIdle);
    }, [addLineOneDataTypeIdle, addLineOneTextIdle, addLineOneSuffixIdle, addTxtSizeIdle]);

    useEffect(() => {
        handleDisplay(addLineTwoDataTypeIdle, addLineTwoTextIdle, addLineTwoSuffixIdle, addTxtSizeIdle, setAddLineTwoDisplayIdle);
    }, [addLineTwoDataTypeIdle, addLineTwoTextIdle, addLineTwoSuffixIdle, addTxtSizeIdle]);

    useEffect(() => {
        handleDisplay(addLineThreeDataTypeIdle, addLineThreeTextIdle, addLineThreeSuffixIdle, addTxtSizeIdle, setAddLineThreeDisplayIdle);
    }, [addLineThreeDataTypeIdle, addLineThreeTextIdle, addLineThreeSuffixIdle, addTxtSizeIdle]);

    useEffect(() => {
        handleDisplay(addLineOneDataTypePnc, addLineOneTextPnc, addLineOneSuffixPnc, addTxtSizePnc, setAddLineOneDisplayPnc);
    }, [addLineOneDataTypePnc, addLineOneTextPnc, addLineOneSuffixPnc, addTxtSizePnc]);

    useEffect(() => {
        handleDisplay(addLineTwoDataTypePnc, addLineTwoTextPnc, addLineTwoSuffixPnc, addTxtSizePnc, setAddLineTwoDisplayPnc);
    }, [addLineTwoDataTypePnc, addLineTwoTextPnc, addLineTwoSuffixPnc, addTxtSizePnc]);

    useEffect(() => {
        handleDisplay(addLineThreeDataTypePnc, addLineThreeTextPnc, addLineThreeSuffixPnc, addTxtSizePnc, setAddLineThreeDisplayPnc);
    }, [addLineThreeDataTypePnc, addLineThreeTextPnc, addLineThreeSuffixPnc, addTxtSizePnc]);

    useEffect(() => {
        handleDisplay(addLineOneDataTypeAccept, addLineOneTextAccept, addLineOneSuffixAccept, addTxtSizeAccept, setAddLineOneDisplayAccept);
    }, [addLineOneDataTypeAccept, addLineOneTextAccept, addLineOneSuffixAccept, addTxtSizeAccept]);

    useEffect(() => {
        handleDisplay(addLineTwoDataTypeAccept, addLineTwoTextAccept, addLineTwoSuffixAccept, addTxtSizeAccept, setAddLineTwoDisplayAccept);
    }, [addLineTwoDataTypeAccept, addLineTwoTextAccept, addLineTwoSuffixAccept, addTxtSizeAccept]);

    useEffect(() => {
        handleDisplay(addLineThreeDataTypeAccept, addLineThreeTextAccept, addLineThreeSuffixAccept, addTxtSizeAccept, setAddLineThreeDisplayAccept);
    }, [addLineThreeDataTypeAccept, addLineThreeTextAccept, addLineThreeSuffixAccept, addTxtSizeAccept]);

    useEffect(() => {
        handleDisplay(editLineOneDataTypeIdle, editLineOneTextIdle, editLineOneSuffixIdle, editTxtSizeIdle, setEditLineOneDisplayIdle);
    }, [editLineOneDataTypeIdle, editLineOneTextIdle, editLineOneSuffixIdle, editTxtSizeIdle]);

    useEffect(() => {
        handleDisplay(editLineTwoDataTypeIdle, editLineTwoTextIdle, editLineTwoSuffixIdle, editTxtSizeIdle, setEditLineTwoDisplayIdle);
    }, [editLineTwoDataTypeIdle, editLineTwoTextIdle, editLineTwoSuffixIdle, editTxtSizeIdle]);

    useEffect(() => {
        handleDisplay(editLineThreeDataTypeIdle, editLineThreeTextIdle, editLineThreeSuffixIdle, editTxtSizeIdle, setEditLineThreeDisplayIdle);
    }, [editLineThreeDataTypeIdle, editLineThreeTextIdle, editLineThreeSuffixIdle, editTxtSizeIdle]);

    useEffect(() => {
        handleDisplay(editLineOneDataTypePnc, editLineOneTextPnc, editLineOneSuffixPnc, editTxtSizePnc, setEditLineOneDisplayPnc);
    }, [editLineOneDataTypePnc, editLineOneTextPnc, editLineOneSuffixPnc, editTxtSizePnc]);

    useEffect(() => {
        handleDisplay(editLineTwoDataTypePnc, editLineTwoTextPnc, editLineTwoSuffixPnc, editTxtSizePnc, setEditLineTwoDisplayPnc);
    }, [editLineTwoDataTypePnc, editLineTwoTextPnc, editLineTwoSuffixPnc, editTxtSizePnc]);

    useEffect(() => {
        handleDisplay(editLineThreeDataTypePnc, editLineThreeTextPnc, editLineThreeSuffixPnc, editTxtSizePnc, setEditLineThreeDisplayPnc);
    }, [editLineThreeDataTypePnc, editLineThreeTextPnc, editLineThreeSuffixPnc, editTxtSizePnc]);

    useEffect(() => {
        handleDisplay(editLineOneDataTypeAccept, editLineOneTextAccept, editLineOneSuffixAccept, editTxtSizeAccept, setEditLineOneDisplayAccept);
    }, [editLineOneDataTypeAccept, editLineOneTextAccept, editLineOneSuffixAccept, editTxtSizeAccept]);

    useEffect(() => {
        handleDisplay(editLineTwoDataTypeAccept, editLineTwoTextAccept, editLineTwoSuffixAccept, editTxtSizeAccept, setEditLineTwoDisplayAccept);
    }, [editLineTwoDataTypeAccept, editLineTwoTextAccept, editLineTwoSuffixAccept, editTxtSizeAccept]);

    useEffect(() => {
        handleDisplay(editLineThreeDataTypeAccept, editLineThreeTextAccept, editLineThreeSuffixAccept, editTxtSizeAccept, setEditLineThreeDisplayAccept);
    }, [editLineThreeDataTypeAccept, editLineThreeTextAccept, editLineThreeSuffixAccept, editTxtSizeAccept]);

    function clearAddForm(){
        setStoredIndex(undefined);
        setAddTxtSizeIdle(1);
        setAddLineOneDataTypeIdle("");
        setAddLineTwoDataTypeIdle("");
        setAddLineThreeDataTypeIdle("");
        setAddLineOneTextIdle("");
        setAddLineTwoTextIdle("");
        setAddLineThreeTextIdle("");
        setAddLineOneSuffixIdle(false);
        setAddLineTwoSuffixIdle(false);
        setAddLineThreeSuffixIdle(false);
        setAddTabItem("idle");
        setAddTxtSizePnc(1);
        setAddLineOneDataTypePnc("");
        setAddLineTwoDataTypePnc("");
        setAddLineThreeDataTypePnc("");
        setAddLineOneTextPnc("");
        setAddLineTwoTextPnc("");
        setAddLineThreeTextPnc("");
        setAddLineOneSuffixPnc(false);
        setAddLineTwoSuffixPnc(false);
        setAddLineThreeSuffixPnc(false);
        setAddTxtSizeAccept(1);
        setAddLineOneDataTypeAccept("");
        setAddLineTwoDataTypeAccept("");
        setAddLineThreeDataTypeAccept("");
        setAddLineOneTextAccept("");
        setAddLineTwoTextAccept("");
        setAddLineThreeTextAccept("");
        setAddLineOneSuffixAccept(false);
        setAddLineTwoSuffixAccept(false);
        setAddLineThreeSuffixAccept(false);
    }

    function editModal(editIndex){
        let dataIndex, modal, modes;
        if (editRights){
            dataIndex = parseInt(editIndex);
            setStoredIndex(dataIndex);
            document.getElementById("nameE").value = activeData[dataIndex].profile_name;
            modes = activeData[dataIndex]?.modes ? activeData[dataIndex].modes : []
            for (let i=0; i < modes.length; i++){
                if (modes[i]?.mode_id === 1){
                    setEditEntityIdIdle(modes[i].dsp_profile_entity_id);
                    setEditTxtSizeIdle(modes[i].text_size);
                    setEditLineOneDataTypeIdle(modes[i].line_one_data_type_id);
                    setEditLineTwoDataTypeIdle(modes[i].line_two_data_type_id);
                    setEditLineThreeDataTypeIdle(modes[i].line_three_data_type_id);
                    setEditLineOneTextIdle(modes[i].line_one_text);
                    setEditLineTwoTextIdle(modes[i].line_two_text);
                    setEditLineThreeTextIdle(modes[i].line_three_text);
                    setEditLineOneSuffixIdle(modes[i].line_one_text_suffix);
                    setEditLineTwoSuffixIdle(modes[i].line_two_text_suffix);
                    setEditLineThreeSuffixIdle(modes[i].line_three_text_suffix);
                    document.getElementById("edit-three-data-type-idle").required = modes[i].text_size === 1;
                }else if (modes[i]?.mode_id === 2){
                    setEditEntityIdPnc(modes[i].dsp_profile_entity_id);
                    setEditTxtSizePnc(modes[i].text_size);
                    setEditLineOneDataTypePnc(modes[i].line_one_data_type_id);
                    setEditLineTwoDataTypePnc(modes[i].line_two_data_type_id);
                    setEditLineThreeDataTypePnc(modes[i].line_three_data_type_id);
                    setEditLineOneTextPnc(modes[i].line_one_text);
                    setEditLineTwoTextPnc(modes[i].line_two_text);
                    setEditLineThreeTextPnc(modes[i].line_three_text);
                    setEditLineOneSuffixPnc(modes[i].line_one_text_suffix);
                    setEditLineTwoSuffixPnc(modes[i].line_two_text_suffix);
                    setEditLineThreeSuffixPnc(modes[i].line_three_text_suffix);
                    document.getElementById("edit-three-data-type-pnc").required = modes[i].text_size === 1;
                }else if (modes[i]?.mode_id === 3){
                    setEditEntityIdAccept(modes[i].dsp_profile_entity_id);
                    setEditTxtSizeAccept(modes[i].text_size);
                    setEditLineOneDataTypeAccept(modes[i].line_one_data_type_id);
                    setEditLineTwoDataTypeAccept(modes[i].line_two_data_type_id);
                    setEditLineThreeDataTypeAccept(modes[i].line_three_data_type_id);
                    setEditLineOneTextAccept(modes[i].line_one_text);
                    setEditLineTwoTextAccept(modes[i].line_two_text);
                    setEditLineThreeTextAccept(modes[i].line_three_text);
                    setEditLineOneSuffixAccept(modes[i].line_one_text_suffix);
                    setEditLineTwoSuffixAccept(modes[i].line_two_text_suffix);
                    setEditLineThreeSuffixAccept(modes[i].line_three_text_suffix);
                    document.getElementById("edit-three-data-type-accept").required = modes[i].text_size === 1;
                }
            }
            setEditTabItem("idle");
            setEditFormCheck(true);
            modal = new Modal(document.getElementById("editmodal"), {});
            modal.show();
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function filterSubmit(){
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        setDataIdList([]);
        dData.perPage = tmpPerPage;
        setPage(1);
        ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
        formSuccess("Page parameters stored to session.", "filterSubmit", "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    function formAddSubmit(){
        // User add form submit function
        let name, payload;
        if (addRights){
            handleSubmitActions("addSubmit", "loadAddSubmit");
            name = document.getElementById("name").value;
            payload = [{profile_name: name,
                        modes: [
                            {mode_id: 1, text_size: addTxtSizeIdle, line_one_data_type_id: addLineOneDataTypeIdle,
                                line_one_text: addLineOneTextIdle, line_one_text_suffix: addLineOneSuffixIdle,
                                line_two_data_type_id: addLineTwoDataTypeIdle, line_two_text: addLineTwoTextIdle,
                                line_two_text_suffix: addLineTwoSuffixIdle, line_three_data_type_id: addLineThreeDataTypeIdle,
                                line_three_text: addLineThreeTextIdle, line_three_text_suffix: addLineThreeSuffixIdle},
                            {mode_id: 2, text_size: addTxtSizePnc, line_one_data_type_id: addLineOneDataTypePnc,
                                line_one_text: addLineOneTextPnc, line_one_text_suffix: addLineOneSuffixPnc,
                                line_two_data_type_id: addLineTwoDataTypePnc, line_two_text: addLineTwoTextPnc,
                                line_two_text_suffix: addLineTwoSuffixPnc, line_three_data_type_id: addLineThreeDataTypePnc,
                                line_three_text: addLineThreeTextPnc, line_three_text_suffix: addLineThreeSuffixPnc},
                            {mode_id: 3, text_size: addTxtSizeAccept, line_one_data_type_id: addLineOneDataTypeAccept,
                                line_one_text: addLineOneTextAccept, line_one_text_suffix: addLineOneSuffixAccept,
                                line_two_data_type_id: addLineTwoDataTypeAccept, line_two_text: addLineTwoTextAccept,
                                line_two_text_suffix: addLineTwoSuffixAccept, line_three_data_type_id: addLineThreeDataTypeAccept,
                                line_three_text: addLineThreeTextAccept, line_three_text_suffix: addLineThreeSuffixAccept}]
                      }];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "palpendant_profile_add", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0] === true){
                    setRead(false);
                    setDataIdList([]);
                    formSuccess(`${name} has been added.`, "addSubmit", "loadAddSubmit", "cancelAddBtn", "addForm");
                    clearAddForm();
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "addSubmit", "loadAddSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formEditSubmit(){
        // Location add form submit function
        let name, payload, oModes, modes,
            oldPayload;
        if (editRights){
            handleSubmitActions("editSubmit", "loadEditSubmit");
            oModes = [];
            modes = activeData[storedIndex]?.modes ? activeData[storedIndex].modes : [];
            for (let i=0; i < modes.length; i++){
                oModes.push({
                    mode_id: modes[i].mode_id,
                    text_size: modes[i].text_size,
                    line_one_data_type_id: modes[i].line_one_data_type_id,
                    line_one_text: modes[i].line_one_text,
                    line_one_text_suffix: modes[i].line_one_text_suffix,
                    line_two_data_type_id: modes[i].line_two_data_type_id,
                    line_two_text: modes[i].line_two_text,
                    line_two_text_suffix: modes[i].line_two_text_suffix,
                    line_three_data_type_id: modes[i].line_three_data_type_id,
                    line_three_text: modes[i].line_three_text,
                    line_three_text_suffix: modes[i].line_three_text_suffix
                });
            }
            name = document.getElementById("nameE").value;
            payload = [{dsp_profile_id: activeData[storedIndex]?.dsp_profile_id, profile_name: name,
                        modes: [
                            {dsp_profile_entity_id: editEntityIdIdle, mode_id: 1, text_size: editTxtSizeIdle, line_one_data_type_id: editLineOneDataTypeIdle,
                                line_one_text: editLineOneTextIdle, line_one_text_suffix: editLineOneSuffixIdle, modified_by: dData.user,
                                line_two_data_type_id: editLineTwoDataTypeIdle, line_two_text: editLineTwoTextIdle,
                                line_two_text_suffix: editLineTwoSuffixIdle, line_three_data_type_id: editLineThreeDataTypeIdle,
                                line_three_text: editLineThreeTextIdle, line_three_text_suffix: editLineThreeSuffixIdle},
                            {dsp_profile_entity_id: editEntityIdPnc, mode_id: 2, text_size: editTxtSizePnc, line_one_data_type_id: editLineOneDataTypePnc,
                                line_one_text: editLineOneTextPnc, line_one_text_suffix: editLineOneSuffixPnc, modified_by: dData.user,
                                line_two_data_type_id: editLineTwoDataTypePnc, line_two_text: editLineTwoTextPnc,
                                line_two_text_suffix: editLineTwoSuffixPnc, line_three_data_type_id: editLineThreeDataTypePnc,
                                line_three_text: editLineThreeTextPnc, line_three_text_suffix: editLineThreeSuffixPnc},
                            {dsp_profile_entity_id: editEntityIdAccept, mode_id: 3, text_size: editTxtSizeAccept, line_one_data_type_id: editLineOneDataTypeAccept,
                                line_one_text: editLineOneTextAccept, line_one_text_suffix: editLineOneSuffixAccept, modified_by: dData.user,
                                line_two_data_type_id: editLineTwoDataTypeAccept, line_two_text: editLineTwoTextAccept,
                                line_two_text_suffix: editLineTwoSuffixAccept, line_three_data_type_id: editLineThreeDataTypeAccept,
                                line_three_text: editLineThreeTextAccept, line_three_text_suffix: editLineThreeSuffixAccept}]
                      }];
            oldPayload = [{dsp_profile_id: activeData[storedIndex]?.dsp_profile_id,
                           profile_name: activeData[storedIndex]?.profile_name}];
            for (let i2=0; i2 < oModes.length; i2++){
                oldPayload.push(oModes[i2]);
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "palpendant_profile_edit", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                    if (data[0]){
                        setRead(false);
                        setDataIdList([]);
                        formSuccess(`${name} updated.`, "editSubmit", "loadEditSubmit", "cancelEditBtn");
                        setCount(0);
                    }
                    else{
                        formFail(`Error during save, error code: ${data[1]}`, "editSubmit", "loadEditSubmit");
                    }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deletePerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        if (deleteRights){
            handleSubmitActions(submitBtn, loadBtn);
            payload = [];
            for (let i=0; i < dContent.length; i++){
                payload.push({dsp_profile_id: dContent[i][0]});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "palpendant_profile_delete", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setRead(false);
                    setCount(0);
                    setDataIdList([]);
                    formSuccess("Profile deleted.", submitBtn, loadBtn, closeId);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteBtn"]);
                }
                else{
                    formFail(`Error during delete, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    const tableHeaders = <TableHeaders checkbox={deleteRights} headerData={headerData} checkAll={() => checkAll(ppRules.start, ppRules.end, dataIdList, setDataIdList)}
                                       writeAccess={editRights} sortOrder={sorter.sortOrder} checkboxHeaderId={"uCheckHead"}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} modal={editRights} checkboxlist={dataIdList}
                                       actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["deleteBtn"])} modal_name={"Edit"}/>

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                {deleteRights && <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                     id={"deleteBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                     onClick={() => bulkDeleteModal(ppRules.start, ppRules.end, activeData,
                                         "profile_name", ["dsp_profile_id", ""], "", setDContent)} />}
                <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"}
                            style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                </div>
                {csvButton}
                {addRights && typesLoaded
                    ?   <Button text={"New Profile"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                                icon={true} iconClass={"fe fe-plus me-2"}
                                onClick={() => {
                                     clearAddForm();
                                     showModal("addmodal");
                                     formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                     formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                     formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                     formCheck("addForm", "addSubmit")}} />
                    : <></>
                }
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)} pageAction={(e) => {
                                setOriginLoaded(false);
                                setPageLoaded(false);
                                setTypesLoaded(false);
                                if (dData?.campusData[campusId.toString()]?.is_cloud !== dData?.campusData[e.target.value]?.is_cloud){
                                    window.location.href = "/";
                                }
            }}/>
        </div>
    );

    const footer = (
        <div>
            <Pagination>
                <PaginationItems setPage={setPage} page={page} beginDot={ppRules.beginDot}
                                 endDot={ppRules.endDot} pageMin={ppRules.pageMin} pageMax={ppRules.pageMax}
                                 max={ppRules.max}/>
            </Pagination>
            <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
        </div>
    );

    return (dData?.campusData[dData?.acnt.toString()]?.is_cloud && iAmHigherAuthority(20, dData?.role_weight)) ? (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Settings"} Title={"PalPendant Line Profiles"} content={headerContent}/>
                <div className={"container-fluid"}>
                    {!pageLoaded
                        ?   skeleton
                        :   <table className={"table table-sm table-white table-hover"}>
                                <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {tableHeaders}
                                </thead>
                                <tbody id={"tBody"}>
                                    {tableRows}
                                </tbody>
                            </table>
                    }
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <Footer center={footer}/>
            </div>
            <div className={"modal fade"} id={"addmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Line Profile</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"addForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"name"}
                                           onKeyUp={() => formCheck("addForm", "addSubmit")}
                                           required={true} pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                    <label htmlFor={"name"}>Profile Name</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a name
                                    </div>
                                </div>
                                <ul className={"nav nav-tabs nav-overflow header-tabs mb-3"}>
                                    <li key={"set-idle"} className={"nav-item"}>
                                        <Button text={"Idle Mode"} id={"add-idle-tab"} class={"nav-link"}
                                                onClick={() => setAddTabItem("idle")}/>
                                    </li>
                                    <li key={"set-pnc"} className={"nav-item"}>
                                        <Button text={"Panic Mode"} id={"add-pnc-tab"}
                                                 class={"nav-link"}
                                                onClick={() => setAddTabItem("pnc")}/>
                                    </li>
                                    <li key={"set-accept"} className={"nav-item"}>
                                        <Button text={"Accepted Mode"} id={"add-accept-tab"}
                                                 class={"nav-link"}
                                                onClick={() => setAddTabItem("accept")}/>
                                    </li>
                                </ul>
                                <div className={addTabItem === "idle" ? "d-block" : "d-none"}>
                                    <form id={"addIdleForm"} className={"was-validated"}>
                                        <div className={"row mb-4"}>
                                            <div className={"form-floating mb-1 col-7"} id={"add-txt-size-div"}>
                                                <select className={"form-select"} id={"add-txt-size"} value={addTxtSizeIdle}
                                                        required={true}
                                                        onChange={(e) => {
                                                            setAddTxtSizeIdle(parseInt(e.target.value));
                                                            if (parseInt(e.target.value) === 1) {
                                                                setAddLineThreeDataTypeIdle("");
                                                                setAddLineThreeTextIdle("");
                                                                setAddLineThreeSuffixIdle(false);
                                                            }
                                                            document.getElementById("add-three-data-type-idle").required = false;
                                                            formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                            formCheck("addForm", "addSubmit");
                                                        }}>
                                                    <option value={1}>Standard 3-line</option>
                                                    <option value={2}>Larger 2-line</option>
                                                </select>
                                                <label className={"ms-3"} htmlFor={"add-txt-size"}>Text Size</label>
                                                <div className={"invalid-feedback"}>
                                                    Size of text determines how many lines
                                                </div>
                                            </div>
                                            <div className={"col-4 border rounded ms-4"} style={{height: "85px"}}>
                                                <p className={"fs-5 d-inline-block w-75 mb-0 border-bottom"}>7:14</p>
                                                <p className={"fs-5 w-25 align-right mb-0 border-bottom"}>95% 4</p>
                                                {/*<hr className={"my-0"}/>*/}
                                                <p className={`${addTxtSizeIdle === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{addLineOneDisplayIdle}</p>
                                                <p className={`${addTxtSizeIdle === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{addLineTwoDisplayIdle}</p>
                                                <p className={`${addTxtSizeIdle === 2 ? "fs-3 d-none" : "fs-5 d-block"} mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{addLineThreeDisplayIdle}</p>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"add-one-data-type-div"}>
                                                    <select className={"form-select"} id={"add-one-data-type-idle"}
                                                            value={addLineOneDataTypeIdle}
                                                            required={true} onChange={(e) => {
                                                        setAddLineOneDataTypeIdle(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                        formCheck("addForm", "addSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-1-type-option-idle-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"add-one-data-type-idle"}>Line 1 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"} id={"line-one-text-idle"}
                                                           value={addLineOneTextIdle}
                                                           onKeyUp={(e) => {
                                                               setAddLineOneTextIdle(e.target.value);
                                                               formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setAddLineOneTextIdle(e.target.value);
                                                               formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-one-text-idle"}>Line 1 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"add-line-one-suffix-idle"} checked={addLineOneSuffixIdle}
                                                           onChange={(e) => {
                                                               setAddLineOneSuffixIdle(e.target.checked);
                                                               formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"add-line-one-suffix-idle"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"add-two-data-type-div-idle"}>
                                                    <select className={"form-select"} id={"add-two-data-type-idle"}
                                                            value={addLineTwoDataTypeIdle}
                                                            required={true} onChange={(e) => {
                                                        setAddLineTwoDataTypeIdle(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                        formCheck("addForm", "addSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-2-type-option-idle-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"add-two-data-type-idle"}>Line 2 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"} id={"line-two-text-idle"}
                                                           value={addLineTwoTextIdle}
                                                           onKeyUp={(e) => {
                                                               setAddLineTwoTextIdle(e.target.value);
                                                               formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setAddLineTwoTextIdle(e.target.value);
                                                               formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-one-text-idle"}>Line 2 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"add-line-two-suffix-idle"} checked={addLineTwoSuffixIdle}
                                                           onChange={(e) => {
                                                               setAddLineTwoSuffixIdle(e.target.checked);
                                                               formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"add-line-two-suffix-idle"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`row${addTxtSizeIdle === 2 ? " d-none" : ""}`}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"add-three-data-type-div-idle"}>
                                                    <select className={"form-select"} id={"add-three-data-type-idle"}
                                                            value={addLineThreeDataTypeIdle}
                                                            required={true} onChange={(e) => {
                                                        setAddLineThreeDataTypeIdle(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                        formCheck("addForm", "addSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-3-type-option-idle-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"add-three-data-type-idle"}>Line 3 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"line-three-text-idle"}
                                                           value={addLineThreeTextIdle}
                                                           onKeyUp={(e) => {
                                                               setAddLineThreeTextIdle(e.target.value);
                                                               formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setAddLineThreeTextIdle(e.target.value);
                                                               formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-three-text-idle"}>Line 3 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"add-line-three-suffix-idle"} checked={addLineThreeSuffixIdle}
                                                           onChange={(e) => {
                                                               setAddLineThreeSuffixIdle(e.target.checked);
                                                               formCheckV2("addIdleForm", "add-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"add-line-three-suffix-idle"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className={addTabItem === "pnc" ? "d-block" : "d-none"}>
                                    <form id={"addPncForm"} className={"was-validated"}>
                                        <div className={"row mb-4"}>
                                            <div className={"form-floating mb-1 col-7"} id={"add-txt-size-div-pnc"}>
                                                <select className={"form-select"} id={"add-txt-size-pnc"} value={addTxtSizePnc}
                                                        required={true}
                                                        onChange={(e) => {
                                                            setAddTxtSizePnc(parseInt(e.target.value));
                                                            if (parseInt(e.target.value) === 1) {
                                                                setAddLineThreeDataTypePnc("");
                                                                setAddLineThreeTextPnc("");
                                                                setAddLineThreeSuffixPnc(false);
                                                            }
                                                            document.getElementById("add-three-data-type-pnc").required = false;
                                                            formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                            formCheck("addForm", "addSubmit");
                                                        }}>
                                                    <option value={1}>Standard 3-line</option>
                                                    <option value={2}>Larger 2-line</option>
                                                </select>
                                                <label className={"ms-3"} htmlFor={"add-txt-size-pnc"}>Text Size</label>
                                                <div className={"invalid-feedback"}>
                                                    Size of text determines how many lines
                                                </div>
                                            </div>
                                            <div className={"col-4 border rounded ms-4"} style={{height: "85px"}}>
                                                <p className={"fs-5 d-inline-block w-75 mb-0 border-bottom"}>7:14</p>
                                                <p className={"fs-5 w-25 align-right mb-0 border-bottom"}>95% 4</p>
                                                {/*<hr className={"my-0"}/>*/}
                                                <p className={`${addTxtSizePnc === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{addLineOneDisplayPnc}</p>
                                                <p className={`${addTxtSizePnc === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{addLineTwoDisplayPnc}</p>
                                                <p className={`${addTxtSizePnc === 2 ? "fs-3 d-none" : "fs-5 d-block"} mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{addLineThreeDisplayPnc}</p>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"add-one-data-type-div-pnc"}>
                                                    <select className={"form-select"} id={"add-one-data-type-pnc"}
                                                            value={addLineOneDataTypePnc}
                                                            required={true} onChange={(e) => {
                                                        setAddLineOneDataTypePnc(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                        formCheck("addForm", "addSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-1-type-option-pnc-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"add-one-data-type-pnc"}>Line 1 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"} id={"line-one-text-pnc"}
                                                           value={addLineOneTextPnc}
                                                           onKeyUp={(e) => {
                                                               setAddLineOneTextPnc(e.target.value);
                                                               formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setAddLineOneTextPnc(e.target.value);
                                                               formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-one-text-pnc"}>Line 1 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"add-line-one-suffix-pnc"} checked={addLineOneSuffixPnc}
                                                           onChange={(e) => {
                                                               setAddLineOneSuffixPnc(e.target.checked);
                                                               formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"add-line-one-suffix-pnc"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"add-two-data-type-div-pnc"}>
                                                    <select className={"form-select"} id={"add-two-data-type-pnc"}
                                                            value={addLineTwoDataTypePnc}
                                                            required={true} onChange={(e) => {
                                                        setAddLineTwoDataTypePnc(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                        formCheck("addForm", "addSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-2-type-option-pnc-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"add-two-data-type-pnc"}>Line 2 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"} id={"line-two-text-pnc"}
                                                           value={addLineTwoTextPnc}
                                                           onKeyUp={(e) => {
                                                               setAddLineTwoTextPnc(e.target.value);
                                                               formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setAddLineTwoTextPnc(e.target.value);
                                                               formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-one-text-pnc"}>Line 2 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"add-line-two-suffix-pnc"} checked={addLineTwoSuffixPnc}
                                                           onChange={(e) => {
                                                               setAddLineTwoSuffixPnc(e.target.checked);
                                                               formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"add-line-two-suffix-pnc"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`row${addTxtSizePnc === 2 ? " d-none" : ""}`}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"add-three-data-type-div-pnc"}>
                                                    <select className={"form-select"} id={"add-three-data-type-pnc"}
                                                            value={addLineThreeDataTypePnc}
                                                            required={true} onChange={(e) => {
                                                        setAddLineThreeDataTypePnc(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                        formCheck("addForm", "addSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-3-type-option-pnc-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"add-three-data-type-pnc"}>Line 3 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"line-three-text-pnc"}
                                                           value={addLineThreeTextPnc}
                                                           onKeyUp={(e) => {
                                                               setAddLineThreeTextPnc(e.target.value);
                                                               formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setAddLineThreeTextPnc(e.target.value);
                                                               formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-three-text-pnc"}>Line 3 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"add-line-three-suffix-pnc"} checked={addLineThreeSuffixPnc}
                                                           onChange={(e) => {
                                                               setAddLineThreeSuffixPnc(e.target.checked);
                                                               formCheckV2("addPncForm", "add-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"add-line-three-suffix-pnc"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className={addTabItem === "accept" ? "d-block" : "d-none"}>
                                    <form id={"addAcceptForm"} className={"was-validated"}>
                                        <div className={"row mb-4"}>
                                            <div className={"form-floating mb-1 col-7"} id={"add-txt-size-div-accept"}>
                                                <select className={"form-select"} id={"add-txt-size-accept"} value={addTxtSizeAccept}
                                                        required={true}
                                                        onChange={(e) => {
                                                            setAddTxtSizeAccept(parseInt(e.target.value));
                                                            if (parseInt(e.target.value) === 1) {
                                                                setAddLineThreeDataTypeAccept("");
                                                                setAddLineThreeTextAccept("");
                                                                setAddLineThreeSuffixAccept(false);
                                                            }
                                                            document.getElementById("add-three-data-type-accept").required = false;
                                                            formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                            formCheck("addForm", "addSubmit");
                                                        }}>
                                                    <option value={1}>Standard 3-line</option>
                                                    <option value={2}>Larger 2-line</option>
                                                </select>
                                                <label className={"ms-3"} htmlFor={"add-txt-size-accept"}>Text Size</label>
                                                <div className={"invalid-feedback"}>
                                                    Size of text determines how many lines
                                                </div>
                                            </div>
                                            <div className={"col-4 border rounded ms-4"} style={{height: "85px"}}>
                                                <p className={"fs-5 d-inline-block w-75 mb-0 border-bottom"}>7:14</p>
                                                <p className={"fs-5 w-25 align-right mb-0 border-bottom"}>95% 4</p>
                                                {/*<hr className={"my-0"}/>*/}
                                                <p className={`${addTxtSizeAccept === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{addLineOneDisplayAccept}</p>
                                                <p className={`${addTxtSizeAccept === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{addLineTwoDisplayAccept}</p>
                                                <p className={`${addTxtSizeAccept === 2 ? "fs-3 d-none" : "fs-5 d-block"} mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{addLineThreeDisplayAccept}</p>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"add-one-data-type-div-accept"}>
                                                    <select className={"form-select"} id={"add-one-data-type-accept"}
                                                            value={addLineOneDataTypeAccept}
                                                            required={true} onChange={(e) => {
                                                        setAddLineOneDataTypeAccept(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                        formCheck("addForm", "addSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-1-type-option-accept-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"add-one-data-type-accept"}>Line 1 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"} id={"line-one-text-accept"}
                                                           value={addLineOneTextAccept}
                                                           onKeyUp={(e) => {
                                                               setAddLineOneTextAccept(e.target.value);
                                                               formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setAddLineOneTextAccept(e.target.value);
                                                               formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-one-text-accept"}>Line 1 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"add-line-one-suffix-accept"} checked={addLineOneSuffixAccept}
                                                           onChange={(e) => {
                                                               setAddLineOneSuffixAccept(e.target.checked);
                                                               formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"add-line-one-suffix-accept"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"add-two-data-type-div-accept"}>
                                                    <select className={"form-select"} id={"add-two-data-type-accept"}
                                                            value={addLineTwoDataTypeAccept}
                                                            required={true} onChange={(e) => {
                                                        setAddLineTwoDataTypeAccept(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                        formCheck("addForm", "addSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-2-type-option-accept-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"add-two-data-type"}>Line 2 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"} id={"line-two-text-accept"}
                                                           value={addLineTwoTextAccept}
                                                           onKeyUp={(e) => {
                                                               setAddLineTwoTextAccept(e.target.value);
                                                               formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setAddLineTwoTextAccept(e.target.value);
                                                               formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-one-text"}>Line 2 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"add-line-two-suffix-accept"} checked={addLineTwoSuffixAccept}
                                                           onChange={(e) => {
                                                               setAddLineTwoSuffixAccept(e.target.checked);
                                                               formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"add-line-two-suffix"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`row${addTxtSizeAccept === 2 ? " d-none" : ""}`}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"add-three-data-type-div-accept"}>
                                                    <select className={"form-select"} id={"add-three-data-type-accept"}
                                                            value={addLineThreeDataTypeAccept}
                                                            required={true} onChange={(e) => {
                                                        setAddLineThreeDataTypeAccept(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                        formCheck("addForm", "addSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-3-type-option-accept-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"add-three-data-type"}>Line 3 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"line-three-text-accept"}
                                                           value={addLineThreeTextAccept}
                                                           onKeyUp={(e) => {
                                                               setAddLineThreeTextAccept(e.target.value);
                                                               formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setAddLineThreeTextAccept(e.target.value);
                                                               formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-three-text-accept"}>Line 3 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"add-line-three-suffix-accept"} checked={addLineThreeSuffixAccept}
                                                           onChange={(e) => {
                                                               setAddLineThreeSuffixAccept(e.target.checked);
                                                               formCheckV2("addAcceptForm", "add-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("addForm", "addSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"add-line-three-suffix-accept"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddBtn"}
                                        data-bs-dismiss={"modal"} onClick={() => clearAddForm()}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true}
                                        spinner={true} text={"Loading"} id={"loadAddSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"}
                                        onClick={() => formAddSubmit()} id={"addSubmit"}>Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticEditBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticEditBackdropLabel"}>Edit Profile</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"editForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"nameE"}
                                           onKeyUp={() => formCheck("editForm", "editSubmit")}
                                           required={true} pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                    <label htmlFor={"nameE"}>Profile Name</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a name
                                    </div>
                                </div>
                                <ul className={"nav nav-tabs nav-overflow header-tabs mb-3"}>
                                    <li key={"set-idle-edit"} className={"nav-item"}>
                                        <Button text={"Idle Mode"} id={"edit-idle-tab"} class={"nav-link"}
                                                onClick={() => setEditTabItem("idle")}/>
                                    </li>
                                    <li key={"set-pnc-edit"} className={"nav-item"}>
                                        <Button text={"Panic Mode"} id={"edit-pnc-tab"}
                                                class={"nav-link"}
                                                onClick={() => setEditTabItem("pnc")}/>
                                    </li>
                                    <li key={"set-accept-edit"} className={"nav-item"}>
                                        <Button text={"Accepted Mode"} id={"edit-accept-tab"}
                                                class={"nav-link"}
                                                onClick={() => setEditTabItem("accept")}/>
                                    </li>
                                </ul>
                                <div className={editTabItem === "idle" ? "d-block" : "d-none"}>
                                    <form id={"editIdleForm"} className={"was-validated"}>
                                        <div className={"row mb-4"}>
                                            <div className={"form-floating mb-1 col-7"} id={"edit-txt-size-div"}>
                                                <select className={"form-select"} id={"edit-txt-size"}
                                                        value={editTxtSizeIdle}
                                                        required={true}
                                                        onChange={(e) => {
                                                            setEditTxtSizeIdle(parseInt(e.target.value));
                                                            if (parseInt(e.target.value) === 1) {
                                                                setEditLineThreeDataTypeIdle("");
                                                                setEditLineThreeTextIdle("");
                                                                setEditLineThreeSuffixIdle(false);
                                                            }
                                                            document.getElementById("edit-three-data-type-idle").required = parseInt(e.target.value) === 1;
                                                            formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                            formCheck("editForm", "editSubmit");
                                                        }}>
                                                    <option value={1}>Standard 3-line</option>
                                                    <option value={2}>Larger 2-line</option>
                                                </select>
                                                <label className={"ms-3"} htmlFor={"edit-txt-size"}>Text Size</label>
                                                <div className={"invalid-feedback"}>
                                                    Size of text determines how many lines
                                                </div>
                                            </div>
                                            <div className={"col-4 border rounded ms-4"} style={{height: "85px"}}>
                                                <p className={"fs-5 d-inline-block w-75 mb-0 border-bottom"}>7:14</p>
                                                <p className={"fs-5 w-25 align-right mb-0 border-bottom"}>95% 4</p>
                                                {/*<hr className={"my-0"}/>*/}
                                                <p className={`${editTxtSizeIdle === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{editLineOneDisplayIdle}</p>
                                                <p className={`${editTxtSizeIdle === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{editLineTwoDisplayIdle}</p>
                                                <p className={`${editTxtSizeIdle === 2 ? "fs-3 d-none" : "fs-5 d-block"} mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{editLineThreeDisplayIdle}</p>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"edit-one-data-type-div"}>
                                                    <select className={"form-select"} id={"edit-one-data-type-idle"}
                                                            value={editLineOneDataTypeIdle}
                                                            required={true} onChange={(e) => {
                                                        setEditLineOneDataTypeIdle(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                        formCheck("editForm", "editSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`edit-line-1-type-option-idle-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"edit-one-data-type-idle"}>Line 1 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"edit-line-one-text-idle"}
                                                           value={editLineOneTextIdle}
                                                           onKeyUp={(e) => {
                                                               setEditLineOneTextIdle(e.target.value);
                                                               formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setEditLineOneTextIdle(e.target.value);
                                                               formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"edit-line-one-text-idle"}>Line 1 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"edit-line-one-suffix-idle"}
                                                           checked={editLineOneSuffixIdle}
                                                           onChange={(e) => {
                                                               setEditLineOneSuffixIdle(e.target.checked);
                                                               formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"edit-line-one-suffix-idle"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"edit-two-data-type-div-idle"}>
                                                    <select className={"form-select"} id={"edit-two-data-type-idle"}
                                                            value={editLineTwoDataTypeIdle}
                                                            required={true} onChange={(e) => {
                                                        setEditLineTwoDataTypeIdle(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                        formCheck("editForm", "editSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`edit-line-2-type-option-idle-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"edit-two-data-type-idle"}>Line 2 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"edit-line-two-text-idle"}
                                                           value={editLineTwoTextIdle}
                                                           onKeyUp={(e) => {
                                                               setEditLineTwoTextIdle(e.target.value);
                                                               formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setEditLineTwoTextIdle(e.target.value);
                                                               formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"edit-line-one-text-idle"}>Line 2 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"edit-line-two-suffix-idle"}
                                                           checked={editLineTwoSuffixIdle}
                                                           onChange={(e) => {
                                                               setEditLineTwoSuffixIdle(e.target.checked);
                                                               formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"edit-line-two-suffix-idle"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`row${editTxtSizeIdle === 2 ? " d-none" : ""}`}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"edit-three-data-type-div-idle"}>
                                                    <select className={"form-select"} id={"edit-three-data-type-idle"}
                                                            value={editLineThreeDataTypeIdle}
                                                            required={true} onChange={(e) => {
                                                        setEditLineThreeDataTypeIdle(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                        formCheck("editForm", "editSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`edit-line-3-type-option-idle-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"edit-three-data-type-idle"}>Line 3 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"edit-line-three-text-idle"}
                                                           value={editLineThreeTextIdle}
                                                           onKeyUp={(e) => {
                                                               setEditLineThreeTextIdle(e.target.value);
                                                               formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setEditLineThreeTextIdle(e.target.value);
                                                               formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"edit-line-three-text-idle"}>Line 3 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"edit-line-three-suffix-idle"}
                                                           checked={editLineThreeSuffixIdle}
                                                           onChange={(e) => {
                                                               setEditLineThreeSuffixIdle(e.target.checked);
                                                               formCheckV2("editIdleForm", "edit-idle-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"edit-line-three-suffix-idle"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className={editTabItem === "pnc" ? "d-block" : "d-none"}>
                                    <form id={"editPncForm"} className={"was-validated"}>
                                        <div className={"row mb-4"}>
                                            <div className={"form-floating mb-1 col-7"} id={"edit-txt-size-div-pnc"}>
                                                <select className={"form-select"} id={"edit-txt-size-pnc"}
                                                        value={editTxtSizePnc}
                                                        required={true}
                                                        onChange={(e) => {
                                                            setEditTxtSizePnc(parseInt(e.target.value));
                                                            if (parseInt(e.target.value) === 1) {
                                                                setEditLineThreeDataTypePnc("");
                                                                setEditLineThreeTextPnc("");
                                                                setEditLineThreeSuffixPnc(false);
                                                            }
                                                            document.getElementById("edit-three-data-type-pnc").required = parseInt(e.target.value) === 1;
                                                            formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                            formCheck("editForm", "editSubmit");
                                                        }}>
                                                    <option value={1}>Standard 3-line</option>
                                                    <option value={2}>Larger 2-line</option>
                                                </select>
                                                <label className={"ms-3"} htmlFor={"edit-txt-size-pnc"}>Text Size</label>
                                                <div className={"invalid-feedback"}>
                                                    Size of text determines how many lines
                                                </div>
                                            </div>
                                            <div className={"col-4 border rounded ms-4"} style={{height: "85px"}}>
                                                <p className={"fs-5 d-inline-block w-75 mb-0 border-bottom"}>7:14</p>
                                                <p className={"fs-5 w-25 align-right mb-0 border-bottom"}>95% 4</p>
                                                {/*<hr className={"my-0"}/>*/}
                                                <p className={`${editTxtSizePnc === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{editLineOneDisplayPnc}</p>
                                                <p className={`${editTxtSizePnc === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{editLineTwoDisplayPnc}</p>
                                                <p className={`${editTxtSizePnc === 2 ? "fs-3 d-none" : "fs-5 d-block"} mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{editLineThreeDisplayPnc}</p>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"edit-one-data-type-div-pnc"}>
                                                    <select className={"form-select"} id={"edit-one-data-type-pnc"}
                                                            value={editLineOneDataTypePnc}
                                                            required={true} onChange={(e) => {
                                                        setEditLineOneDataTypePnc(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                        formCheck("editForm", "editSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`edit-line-1-type-option-pnc-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"edit-one-data-type-pnc"}>Line 1 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"edit-line-one-text-pnc"}
                                                           value={editLineOneTextPnc}
                                                           onKeyUp={(e) => {
                                                               setEditLineOneTextPnc(e.target.value);
                                                               formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setEditLineOneTextPnc(e.target.value);
                                                               formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-one-text-pnc"}>Line 1 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"edit-line-one-suffix-pnc"} checked={editLineOneSuffixPnc}
                                                           onChange={(e) => {
                                                               setEditLineOneSuffixPnc(e.target.checked);
                                                               formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"edit-line-one-suffix-pnc"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"edit-two-data-type-div-pnc"}>
                                                    <select className={"form-select"} id={"edit-two-data-type-pnc"}
                                                            value={editLineTwoDataTypePnc}
                                                            required={true} onChange={(e) => {
                                                        setEditLineTwoDataTypePnc(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                        formCheck("editForm", "editSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`line-2-type-option-pnc-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"edit-two-data-type-pnc"}>Line 2 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"edit-line-two-text-pnc"}
                                                           value={editLineTwoTextPnc}
                                                           onKeyUp={(e) => {
                                                               setEditLineTwoTextPnc(e.target.value);
                                                               formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setEditLineTwoTextPnc(e.target.value);
                                                               formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"line-one-text-pnc"}>Line 2 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"edit-line-two-suffix-pnc"} checked={editLineTwoSuffixPnc}
                                                           onChange={(e) => {
                                                               setEditLineTwoSuffixPnc(e.target.checked);
                                                               formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"edit-line-two-suffix-pnc"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`row${editTxtSizePnc === 2 ? " d-none" : ""}`}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"edit-three-data-type-div-pnc"}>
                                                    <select className={"form-select"} id={"edit-three-data-type-pnc"}
                                                            value={editLineThreeDataTypePnc}
                                                            required={true} onChange={(e) => {
                                                        setEditLineThreeDataTypePnc(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                        formCheck("editForm", "editSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`edit-line-3-type-option-pnc-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"edit-three-data-type-pnc"}>Line 3 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"edit-line-three-text-pnc"}
                                                           value={editLineThreeTextPnc}
                                                           onKeyUp={(e) => {
                                                               setEditLineThreeTextPnc(e.target.value);
                                                               formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setEditLineThreeTextPnc(e.target.value);
                                                               formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"edit-line-three-text-pnc"}>Line 3 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"edit-line-three-suffix-pnc"}
                                                           checked={editLineThreeSuffixPnc}
                                                           onChange={(e) => {
                                                               setEditLineThreeSuffixPnc(e.target.checked);
                                                               formCheckV2("editPncForm", "edit-pnc-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"edit-line-three-suffix-pnc"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className={editTabItem === "accept" ? "d-block" : "d-none"}>
                                    <form id={"editAcceptForm"} className={"was-validated"}>
                                        <div className={"row mb-4"}>
                                            <div className={"form-floating mb-1 col-7"} id={"edit-txt-size-div-accept"}>
                                                <select className={"form-select"} id={"edit-txt-size-accept"}
                                                        value={editTxtSizeAccept}
                                                        required={true}
                                                        onChange={(e) => {
                                                            setEditTxtSizeAccept(parseInt(e.target.value));
                                                            if (parseInt(e.target.value) === 1) {
                                                                setEditLineThreeDataTypeAccept("");
                                                                setEditLineThreeTextAccept("");
                                                                setEditLineThreeSuffixAccept(false);
                                                            }
                                                            document.getElementById("edit-three-data-type-accept").required = parseInt(e.target.value) === 1;
                                                            formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                            formCheck("editForm", "editSubmit");
                                                        }}>
                                                    <option value={1}>Standard 3-line</option>
                                                    <option value={2}>Larger 2-line</option>
                                                </select>
                                                <label className={"ms-3"} htmlFor={"edit-txt-size-accept"}>Text
                                                    Size</label>
                                                <div className={"invalid-feedback"}>
                                                    Size of text determines how many lines
                                                </div>
                                            </div>
                                            <div className={"col-4 border rounded ms-4"} style={{height: "85px"}}>
                                                <p className={"fs-5 d-inline-block w-75 mb-0 border-bottom"}>7:14</p>
                                                <p className={"fs-5 w-25 align-right mb-0 border-bottom"}>95% 4</p>
                                                {/*<hr className={"my-0"}/>*/}
                                                <p className={`${editTxtSizeAccept === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{editLineOneDisplayAccept}</p>
                                                <p className={`${editTxtSizeAccept === 2 ? "fs-3" : "fs-5"} d-block mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{editLineTwoDisplayAccept}</p>
                                                <p className={`${editTxtSizeAccept === 2 ? "fs-3 d-none" : "fs-5 d-block"} mb-0`}
                                                   style={{whiteSpace: "pre-wrap"}}>{editLineThreeDisplayAccept}</p>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"edit-one-data-type-div-accept"}>
                                                    <select className={"form-select"} id={"edit-one-data-type-accept"}
                                                            value={editLineOneDataTypeAccept}
                                                            required={true} onChange={(e) => {
                                                        setEditLineOneDataTypeAccept(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                        formCheck("editForm", "editSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`edit-line-1-type-option-accept-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"edit-one-data-type-accept"}>Line 1 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"edit-line-one-text-accept"}
                                                           value={editLineOneTextAccept}
                                                           onKeyUp={(e) => {
                                                               setEditLineOneTextAccept(e.target.value);
                                                               formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setEditLineOneTextAccept(e.target.value);
                                                               formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"edit-line-one-text-accept"}>Line 1 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"edit-line-one-suffix-accept"}
                                                           checked={editLineOneSuffixAccept}
                                                           onChange={(e) => {
                                                               setEditLineOneSuffixAccept(e.target.checked);
                                                               formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"edit-line-one-suffix-accept"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"edit-two-data-type-div-accept"}>
                                                    <select className={"form-select"} id={"edit-two-data-type-accept"}
                                                            value={editLineTwoDataTypeAccept}
                                                            required={true} onChange={(e) => {
                                                        setEditLineTwoDataTypeAccept(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                        formCheck("editForm", "editSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`edit-line-2-type-option-accept-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"edit-two-data-type"}>Line 2 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"edit-line-two-text-accept"}
                                                           value={editLineTwoTextAccept}
                                                           onKeyUp={(e) => {
                                                               setEditLineTwoTextAccept(e.target.value);
                                                               formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setEditLineTwoTextAccept(e.target.value);
                                                               formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"edit-line-two-text"}>Line 2 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"edit-line-two-suffix-accept"}
                                                           checked={editLineTwoSuffixAccept}
                                                           onChange={(e) => {
                                                               setEditLineTwoSuffixAccept(e.target.checked);
                                                               formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"edit-line-two-suffix"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`row${editTxtSizeAccept === 2 ? " d-none" : ""}`}>
                                            <div className={"col-4"}>
                                                <div className={"form-floating"} id={"edit-three-data-type-div-accept"}>
                                                    <select className={"form-select"} id={"edit-three-data-type-accept"}
                                                            value={editLineThreeDataTypeAccept}
                                                            required={true} onChange={(e) => {
                                                        setEditLineThreeDataTypeAccept(isNaN(e.target.value) ? e.target.value : parseInt(e.target.value));
                                                        formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                        formCheck("editForm", "editSubmit");
                                                    }}>
                                                        <option value={""}></option>
                                                        {typesData.map((type, index) => {
                                                            return (<option key={`edit-line-3-type-option-accept-${index}`}
                                                                            value={type.data_type_id}>
                                                                {type.data_type_name}
                                                            </option>)
                                                        })}
                                                    </select>
                                                    <label htmlFor={"edit-three-data-type"}>Line 3 Data Type</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-floating mb-3"}>
                                                    <input type={"text"} className={"form-control"}
                                                           id={"edit-line-three-text-accept"}
                                                           value={editLineThreeTextAccept}
                                                           onKeyUp={(e) => {
                                                               setEditLineThreeTextAccept(e.target.value);
                                                               formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           onChange={(e) => {
                                                               setEditLineThreeTextAccept(e.target.value);
                                                               formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}
                                                           required={false}
                                                           pattern={"^[0-9a-zA-Z_\\- ']+$"}/>
                                                    <label htmlFor={"edit-line-three-text-accept"}>Line 3 Custom Text</label>
                                                </div>
                                            </div>
                                            <div className={"col-4"}>
                                                <div className={"form-check form-switch mt-2"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"edit-line-three-suffix-accept"}
                                                           checked={editLineThreeSuffixAccept}
                                                           onChange={(e) => {
                                                               setEditLineThreeSuffixAccept(e.target.checked);
                                                               formCheckV2("editAcceptForm", "edit-accept-tab", "text-primary", "text-danger", false);
                                                               formCheck("editForm", "editSubmit");
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"edit-line-three-suffix-accept"}>
                                                        Add text after
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelEditBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true}
                                        spinner={true} text={"Loading"} id={"loadEditSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"}
                                        onClick={() => formEditSubmit()} id={"editSubmit"}>Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <SingleDeleteModal
                deletePerform={() => deletePerform("deleteSubmit", "loadDeleteSubmit", "confirmClose", ppRules.start, ppRules.end)}
                header={"Delete Area"}/>
            <BulkDeleteModal
                deletePerform={() => deletePerform("bulkDeleteSubmit", "loadBulkDeleteSubmit", "bulkConfirmClose", ppRules.start, ppRules.end)}
                start={ppRules.start} end={ppRules.end} header={"Delete Profile"}/>
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage}
                          setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)}
                          setPage={(sudocode) => setPage(sudocode)}/>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            {/* Floating Help Button - Quarter Circle Corner Shape */}
            <button 
                type={"button"} 
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>PalPendant Line Profiles Page Help</h2>
                            <button type={"button"} className={"btn-close"} id={"helpClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The PalPendant Line Profiles page allows you to configure display profiles for PalPendant devices. 
                                    Each profile defines what information is shown on the pendant's display in different modes (Idle, Panic, and Accepted).
                                </p>
                            </div>
                            
                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-search me-2 text-primary"}></i>Searching and Managing Profiles
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Use the <strong>search bar</strong> to find profiles by name.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the edit icon on any profile row to modify it.
                                    </li>
                                    <li className={"mb-2"}>
                                        Select multiple profiles using checkboxes and click <strong>"Delete"</strong> to remove them.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Export"</strong> to download profile data as a CSV file.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-plus me-2 text-primary"}></i>Creating New Profiles
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click <strong>"New Profile"</strong> to create a new display profile.
                                    </li>
                                    <li className={"mb-2"}>
                                        Enter a <strong>Profile Name</strong> to identify this profile.
                                    </li>
                                    <li className={"mb-2"}>
                                        Configure settings for three modes: <strong>Idle Mode</strong>, <strong>Panic Mode</strong>, and <strong>Accepted Mode</strong>.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the tabs to switch between modes when creating or editing a profile.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-monitor me-2 text-primary"}></i>Display Configuration
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Text Size:</strong> Choose between "Standard 3-line" or "Larger 2-line" display format.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Line Data Types:</strong> Select what information appears on each line (Resident Name, Area Name, Staff Name, or Custom Text).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Custom Text:</strong> Enter static text to display on a line (optional).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Add Text After:</strong> Toggle to place custom text after the data type value, or before it.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Preview:</strong> The preview box shows how the display will look with example data.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-toggle-left me-2 text-primary"}></i>Profile Modes
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Idle Mode:</strong> Display configuration when the pendant is in normal/idle state.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Panic Mode:</strong> Display configuration when a panic alert is active.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Accepted Mode:</strong> Display configuration when an alert has been accepted.
                                    </li>
                                    <li className={"mb-2"}>
                                        Each mode can have different text sizes and line configurations.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-edit me-2 text-primary"}></i>Editing Profiles
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the edit icon on any profile row to modify it.
                                    </li>
                                    <li className={"mb-2"}>
                                        Update the profile name and configure each mode as needed.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the tabs to switch between modes when editing.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Submit"</strong> to save your changes.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-trash-2 me-2 text-primary"}></i>Deleting Profiles
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Select one or more profiles using the checkboxes.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Delete"</strong> to remove the selected profiles.
                                    </li>
                                    <li className={"mb-2"}>
                                        This action cannot be undone, so be certain before confirming deletion.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        When "Standard 3-line" is selected, all three lines must have data types configured.
                                    </li>
                                    <li className={"mb-2"}>
                                        When "Larger 2-line" is selected, only lines 1 and 2 are used (line 3 is hidden).
                                    </li>
                                    <li className={"mb-2"}>
                                        The preview box shows a real-time preview of how the display will appear.
                                    </li>
                                    <li className={"mb-2"}>
                                        Custom text can be used to add labels or separators between data fields.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use "Add text after" to control whether custom text appears before or after the data value.
                                    </li>
                                    <li className={"mb-2"}>
                                        Tab indicators show validation status - red indicates required fields that need attention.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ) : <></>;
};

export default PalPendantSettings;